<span *ngIf="inspectionState === 'Paused'"><i class="fa fa-pause"></i> Paused</span>
<span *ngIf="inspectionState === 'Stopped'" class="text-assertive"><i class="fa fa-stop"></i> Not Contracted</span>
<span *ngIf="inspectionState === 'Never Inspected'"><i class="fa fa-times-circle"></i> Never Inspected</span>
<span *ngIf="inspectionState === 'Overdue'" class="text-assertive"><i class="fa fa-exclamation-circle"></i> Overdue</span>
<span *ngIf="inspectionState === 'Active'" class="text-positive"><i class="fa fa-check-circle"></i> Active</span>
